import apiClient from '@/plugins/apiClient'
let basePath = "/cms/settings";
import qs from 'qs';

export default {
     namespaced: true,
     state:{
          list: [],
          single: null,
          errors: {},
          message: {},
          redirects: {},
          meta: {
               current_page: 1,
               total: 0,
               per_page: 12
          },
          filters: {
               wheres : []
          }
     },
     getters:{
          list: state => state.list,
          single: state => state.single,
          message: state => state.message,
          errors: state => state.errors,
          meta: state => state.meta,
          filters: state => state.filters,
          redirects: state => state.redirects,
     },
     mutations:{
        error(state, err) {
            state.errors = err.response.data
        },
        setList(state, resp) {
            state.list = resp.data
            state.errors = {}
        },
        setMeta(state, resp){
          state.meta = resp.meta
        },
        setRedirects(state, resp){
          state.redirects = resp.data
          state.errors = {}
        },
        setFilters(state, resp){
          state.filters = resp.filters
        },
        setSingle(state, resp){
          state.single = resp.data
          state.errors = {}
        }
     },
     actions:{
          getList({commit, state}, data){
               return new Promise((resolve, reject) => {
                    var params =  qs.stringify(state.filters, { arrayFormat: 'indices' })
                    apiClient.get(basePath+'?page='+state.meta.current_page+'&'+params).then(resp => {
                         commit('setList', resp.data);
                         commit('setMeta', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.get(basePath+'/'+data.id).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          updateSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.patch(basePath+'/'+data.id+'/update',data).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          createSingle({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/create',data).then(resp => {
                         commit('setSingle', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          applicationUpdate({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/app-update',data).then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          sitemapBuilder({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/sitemap-builder',data).then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          getRedirects({commit}){
               return new Promise((resolve, reject) => {
                    apiClient.get(basePath+'/redirects').then(resp => {
                         commit('setRedirects', resp);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          postRedirects({commit}, data){
               return new Promise((resolve, reject) => {
                    apiClient.post(basePath+'/redirects', data).then(resp => {
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          setAsSingle({state}, data){
               state.single = data;
          },
          setMeta({commit}, data){
               commit('setMeta',{meta:data});
               // commit('success', true);
          },
          setFilters({commit}, data){
               commit('setFilters',{filters:data});
          }
     },
}